import { useTranslation } from "react-i18next";
import { Icon, Label, Popup } from "semantic-ui-react";

import { COMMUNICATION_RESULT_STATUSES } from "models";
import "modules/AppointmentDetails/components/Interventions/components/CustomerCommunicationAnswer/CustomerCommunicationAnswer.scss";

type CustomerCommunicationAnswerProps = {
  communicationResultStatus?: COMMUNICATION_RESULT_STATUSES;
  interventionIsDeclinedByCustomer?: boolean;
};

const mappedStatusIcons: Record<COMMUNICATION_RESULT_STATUSES, React.ReactNode | null> = {
  [COMMUNICATION_RESULT_STATUSES.OkStatus]: <Icon size="small" className="user check" color="green" />,
  [COMMUNICATION_RESULT_STATUSES.NotOkStatus]: <Icon size="small" className="user xmark" color="red" />,
  [COMMUNICATION_RESULT_STATUSES.ContactMeStatus]: <Icon size="small" className="phone" color="green" />,
  [COMMUNICATION_RESULT_STATUSES.NotAnsweredStatus]: null
};

export const CustomerCommunicationAnswer = ({ communicationResultStatus, interventionIsDeclinedByCustomer }: CustomerCommunicationAnswerProps) => {
  const { t } = useTranslation();

  if (communicationResultStatus) {
    const icon = mappedStatusIcons[communicationResultStatus];
    return (
      icon && (
        <div className="status-container diagnose-overview-icon">
          <div className="action-icon-container">{icon}</div>
        </div>
      )
    );
  }

  if (interventionIsDeclinedByCustomer)
    return (
      <Popup
        trigger={
          <Label basic className="customer-comm-answer-declined-intervention-label">
            <Icon className="user xmark" color="red" />
          </Label>
        }
        content={t("v8_declined_on_desk_checkin", "Declined on Desk check-in")}
      />
    );

  return null;
};
